import { createSlice } from '@reduxjs/toolkit';
import dayjs from 'dayjs';

let initialState = {
  year: dayjs().format('YYYY'), // 조회연도
  month: dayjs().format('MM'), // 조회월
  half: '', // 반기
  quater: '1', // 분기
  startYear: dayjs().subtract(1, 'year').format('YYYY'), // 조회 시작년도
  endYear: dayjs().format('YYYY'), // 조회 종료년도
  startDate: dayjs().subtract(3, 'year').format('YYYY-MM-DD'), // 조회시작일자
  endDate: dayjs().format('YYYY-MM-DD'), // 조회종료일자
  custList: [], // 사업장 목록
  custCd: '', // 사업장 코드
  depList: [], // 부서 목록
  depCd: '', // 부서 코드
  coList: [], // 회사 목록
  coCd: '', // 회사 코드
  searchText: '', // 검색어
  gubun: '', // 처리상태 (전체/반려/대기/승인)
  modalSearchText: '', // 모달 검색어
  modalStartYear: dayjs().subtract(1, 'year').format('YYYY'), // 모달 조회 시작년도
  modalEndYear: dayjs().format('YYYY'), // 모달 조회 종료년도
};

const SearchReducer = createSlice({
  name: 'SearchInfo',
  initialState,
  reducers: {
    setYear(state, action) {
      state.year = action.payload;
    },
    setMonth(state, action) {
      state.month = action.payload;
    },
    setHalf(state, action) {
      state.half = action.payload;
    },
    setQuarter(state, action) {
      state.quater = action.payload;
    },
    setStartYear(state, action) {
      state.startYear = action.payload;
    },
    setEndYear(state, action) {
      state.endYear = action.payload;
    },
    setStartDate(state, action) {
      state.startDate = action.payload;
    },
    setEndDate(state, action) {
      state.endDate = action.payload;
    },
    setCustList(state, action) {
      state.custList = action.payload;
    },
    setCustCd(state, action) {
      state.custCd = action.payload;
    },
    setDepList(state, action) {
      state.depList = action.payload;
    },
    setDepCd(state, action) {
      state.depCd = action.payload;
    },
    setCoList(state, action) {
      state.coList = action.payload;
    },
    setCoCd(state, action) {
      state.coCd = action.payload;
    },
    setSearchText(state, action) {
      state.searchText = action.payload;
    },
    setGubun(state, action) {
      state.gubun = action.payload;
    },
    setModalSearchText(state, action) {
      state.modalSearchText = action.payload;
    },
    setModalStartYear(state, action) {
      state.modalStartYear = action.payload;
    },
    setModalEndYear(state, action) {
      state.modalEndYear = action.payload;
    },
    setSearchInfo(state, action) {
      // return으로 전체 상태를 새로운 객체로 업데이트
      return { ...state, ...action.payload };
    },
    resetSearchInfo(state) {
      // 상태를 초기값으로 리셋
      return initialState;
    },
  },
});

export const {
  setYear,
  setMonth,
  setHalf,
  setQuarter,
  setStartYear,
  setEndYear,
  setStartDate,
  setEndDate,
  setCustList,
  setCustCd,
  setDepList,
  setDepCd,
  setCoList,
  setCoCd,
  setSearchText,
  setGubun,
  setModalSearchText,
  setModalStartYear,
  setModalEndYear,
  setSearchInfo,
  resetSearchInfo,
} = SearchReducer.actions;

export default SearchReducer.reducer;
